// ** React
import React from 'react'
import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'

// ** Global
import './index.css'
import './wave.css'
import './i18n'

// ** Third
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { ChakraProvider } from '@chakra-ui/react'
import theme from './theme'
import { RecoilRoot } from 'recoil'
import { ReactFlowProvider } from 'reactflow' // ReactFlowProvider를 추가

// ** New Page
import Home from './pages/Home'
import SignIn from './pages/SignIn'
import MyPage from './pages/Mypage'
import SignUp from './pages/SignUp'
import Trading from './pages/Trading'
import News from './pages/News'
import Ranking from './pages/Ranking'
import Store from './pages/Store'
import Strategy from './pages/Strategy'
import Realtime from './pages/Realtime'
import Withdrawal from './pages/Withdrawal'
import Partner from './pages/Partner'
import Community from './pages/Community'
import CommunityDetail from './pages/CommunityDetail'
import CommunityWrite from './pages/CommunityWrite'
import CommunityEdit from './pages/CommunityEdit'
import PointShop from './pages/PointShop'
import Certificate from './pages/Certificate'
import Dashboard from './pages/admin/Dashboard'
import User from './pages/admin/User'
import Sales from './pages/admin/Sales'
import Deposit from './pages/admin/Deposit'
import WithdrawalAdmin from './pages/admin/Withdrawal'
import Subordinate from './pages/admin/Subordinate'
import Bot from './pages/admin/Bot'
import History from './pages/admin/History'
import Spot from './pages/Spot'

const router = createBrowserRouter([
  { path: '/', element: <Home /> }, // 홈
  { path: '/signIn', element: <SignIn /> }, // 로그인
  { path: '/signUp', element: <SignUp /> }, // 회원가입
  { path: '/mypage', element: <MyPage /> }, // 마이페이지
  { path: '/trading', element: <Trading /> }, // 트레이딩
  // { path: '/spot', element: <Spot /> }, // 트레이딩
  { path: '/news', element: <News /> }, // 뉴스
  { path: '/store', element: <Store /> }, // 스토어
  { path: '/strategy', element: <Strategy /> }, // 전략
  { path: '/realtime', element: <Realtime /> }, // 실시간
  { path: '/withdrawal', element: <Withdrawal /> }, // 출금
  { path: '/partner', element: <Partner /> }, // 파트너
  { path: '/community', element: <Community /> }, // 커뮤니티
  { path: '/community/write', element: <CommunityWrite /> }, // 커뮤니티 글 작성
  { path: '/community/:id', element: <CommunityDetail /> }, // 커뮤니티 상세
  { path: '/community/:id/edit', element: <CommunityEdit /> }, // 커뮤니티 글 수정
  { path: '/pointshop', element: <PointShop /> }, // 포인트샵
  { path: '/certificate', element: <Certificate /> }, // 인증서

  // 관리자
  { path: '/admin/dashboard', element: <Dashboard /> },
  { path: '/admin/user', element: <User /> },
  { path: '/admin/deposit', element: <Deposit /> },
  { path: '/admin/withdrawal', element: <WithdrawalAdmin /> },
  { path: '/admin/sales', element: <Sales /> },
  { path: '/admin/subordinate', element: <Subordinate /> },
  { path: '/admin/bot', element: <Bot /> },
  { path: '/admin/history', element: <History /> }
])

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  // <React.StrictMode>
  <ChakraProvider theme={theme}>
    <RecoilRoot>
      <ReactFlowProvider>
        <RouterProvider router={router} />
      </ReactFlowProvider>
    </RecoilRoot>
  </ChakraProvider>
  // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
